import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  ADD_DESIGN,
  DELETE_DESIGN,
  GET_CLIMATE_DATA,
  SAVE_CLIMATE_DATA,
  GET_CUSTOM_CLIMATE,
  GET_DESIGNS,
  UPDATE_DESIGN,
  PLANT_SEARCH,
  GET_PLANT_DATA,
  GET_FREEBIE_PLANT_DATA,
    GET_STRUCTURE_DATA,
  GET_FREEBIE_CLIMATE_DATA
} from "./actionTypes"
import {
  getDesignsSuccess,
  getDesignsFail,
  addDesignFail,
  addDesignSuccess,
  updateDesignSuccess,
  updateDesignFail,
  deleteDesignSuccess,
  deleteDesignFail,
  getClimateDataSuccess,
  getClimateDataFail,
  plantSearchSuccess,
  plantSearchFail,
  getCustomClimateSuccess,
  getCustomClimateFail,
  saveClimateDataSuccess,
  saveClimateDataFail,
  getPlantDataSuccess,
  getPlantDataFail,
    getStructureDataSuccess,
    getStructureDataFail,
  getFreebiePlantDataSuccess,
  getFreebiePlantDataFailure,
  getFreebieClimateDataSuccess,
  getFreebieClimateDataFailure
} from "./actions"

//Include Both Helper File with needed methods
import {
  getDesigns,
  getLoggedInUser,
  addDesign,
  updateDesign,
  deleteDesign,
  getClimateData,
  saveClimateData,
  getCustomClimate,
  getPlantData,
    getStructureData,
  searchPlants, 
  getFreebiePlantData,
  getFreebieClimateData
} from "../../helpers/fakebackend_helper"

function* fetchDesigns() {
  try {
    const user = getLoggedInUser()
    const response = yield call(getDesigns, user)
    yield put(getDesignsSuccess(response))
  } catch (error) {
    yield put(getDesignsFail(error))
  }
}

function* onPlantSearch({ payload: search}) {
  try {
     const response = yield call(searchPlants, search)
     yield put(plantSearchSuccess(response))
  } catch (error) { 
     yield put(plantSearchFail(error))
  }
}

function* onFreebieSearch({ payload: search}) {
  try {
     const response = yield call(getFreebiePlantData, search)
     yield put(getFreebiePlantDataSuccess(response))
  } catch (error) {
     yield put(getFreebiePlantDataFailure(error))
  }
}

function* onAddDesign({ payload: design }) {
  try {
    const response = yield call(addDesign, design)
    yield put(addDesignSuccess(design))
  } catch (error) {
    yield put(addDesignFail(error))
  }
}

function* onUpdateDesign({ payload: design }) {
  try {
    const response = yield call(updateDesign, design)
    console.log(design)
    yield put(updateDesignSuccess(response))
  } catch (error) {
    yield put(updateDesignFail(error))
  }
}

function* onDeleteDesign({ payload: designId }) {
  try {
    const response = yield call(deleteDesign, designId)
    yield put(deleteDesignSuccess(designId))
  } catch (error) {
    yield put(deleteDesignFail(error))
  }
}

function* onGetClimateData({payload : zipcode }) {
  try {
    console.log(zipcode)
    const response = yield call(getClimateData, zipcode)
    yield put(getClimateDataSuccess(response))
  } catch (error) {
    yield put(getClimateDataFail(error))
  }
}

function* onGetFreebieClimateData({payload : zipcode }) {
  try {
    console.log(zipcode)
    const response = yield call(getFreebieClimateData, zipcode)
    yield put(getFreebieClimateDataSuccess(response))
  } catch (error) {
    yield put(getFreebieClimateDataFailure(error))
  }
}

function* onSaveClimateData({payload : climate }) {
  try {
    console.log(climate)
    const response = yield call(saveClimateData, climate)
    yield put(saveClimateDataSuccess(response))
  } catch (error) {
    yield put(saveClimateDataFail(error))
  }
}

function* onGetCustomClimate({payload : user }) {
  try {
    console.log(user)
    const response = yield call(getCustomClimate)
    yield put(getCustomClimateSuccess(response))
  } catch (error) {
    yield put(getCustomClimateFail(error))
  }
}

function* onGetPlantData() {
  try {
    const response = yield call(getPlantData)
    yield put(getPlantDataSuccess(response))
  } catch (error) {
    yield put(getPlantDataFail(error))
  }
}

function* onGetStructureData() {
  try {
    const response = yield call(getStructureData)
    yield put(getStructureDataSuccess(response))
  } catch (error) {
    yield put(getPlantDataFail(error))
  }
}

function* designerSaga() {
  yield takeEvery(GET_DESIGNS, fetchDesigns)
  yield takeEvery(ADD_DESIGN, onAddDesign)
  yield takeEvery(UPDATE_DESIGN, onUpdateDesign)
  yield takeEvery(DELETE_DESIGN, onDeleteDesign)
  yield takeEvery(GET_CLIMATE_DATA, onGetClimateData)
  yield takeEvery(GET_FREEBIE_CLIMATE_DATA, onGetFreebieClimateData)
  yield takeEvery(SAVE_CLIMATE_DATA, onSaveClimateData)
  yield takeEvery(GET_CUSTOM_CLIMATE, onGetCustomClimate)
  yield takeEvery(GET_PLANT_DATA, onGetPlantData)
  yield takeEvery(GET_STRUCTURE_DATA, onGetStructureData)
  yield takeEvery(GET_FREEBIE_PLANT_DATA, onFreebieSearch)
  yield takeEvery(PLANT_SEARCH, onPlantSearch)
}

export default designerSaga
